import { FUNCTIONAL_TEST_ID_ATTR } from '../constants';
export const setElementTestId = (elem, id) => elem.setAttribute(FUNCTIONAL_TEST_ID_ATTR, id);
